module.exports = __webpack_public_path__ + "media/3-22a.bb385e67.mp4";